













import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class VPrintButton extends Vue {
  @Prop({ type: Boolean }) disabled?: boolean;
}
